import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import SubscriptionStatusBanner from "../Components/SubscriptionStatusBanner";
import FreeTierUpgradeBanner from "../Components/FreeTierUpgradeBanner";

const DashboardLayout = () => {
  return (
    <div className="flex h-screen justify-between bg-[#131313] text-white antialiased">
      <Sidebar />

      <div className="flex w-full min-w-0 flex-1 flex-col overflow-hidden">
        <FreeTierUpgradeBanner />
        <SubscriptionStatusBanner />
        <div className="min-h-0 flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
